import FULL_STOP_MAP from '../data/FULL_STOP_MAP.js';

function StopHeader({ stopInfo, isFavorite, onToggleFavorite }) {
    if (!stopInfo) {
        return (
            <div className="stop-header-card">
                <p className="stop-header-loading">Ładowanie informacji o przystanku...</p>
            </div>
        );
    }

    const stopIdString = stopInfo.stopId.toString();
    const mappedName = FULL_STOP_MAP[stopIdString];
    let fullTitle;

    if (mappedName) {
        fullTitle = mappedName;
    } else {
        const mainName = stopInfo.stopDesc;
        const subName = stopInfo.subName;
        fullTitle = subName ? `${mainName} ${subName}` : mainName;
    }

    return (
        <div className="stop-header-card">
            <div className="stop-header-top">
                <span className="stop-live-dot">
                    <span className="live-dot-inner" />
                    <span className="live-dot-pulse" />
                    NA ŻYWO
                </span>
                <span className="stop-updated-hint">Aktualizacja co 30s</span>
            </div>
            <div className="stop-header-main">
                <div className="stop-header-info">
                    <h1 className="stop-header-title">{fullTitle}</h1>
                    <div className="stop-header-meta">
                        <span className="stop-code-pill">Kod: {stopInfo.stopId}</span>
                    </div>
                </div>
                <button
                    className={`stop-fav-btn${isFavorite ? ' stop-fav-btn--active' : ''}`}
                    onClick={onToggleFavorite}
                    title={isFavorite ? 'Usuń z ulubionych' : 'Dodaj do ulubionych'}
                    aria-label={isFavorite ? 'Usuń z ulubionych' : 'Dodaj do ulubionych'}
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill={isFavorite ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.5-7 10-7 10z"/>
                    </svg>
                </button>
            </div>
        </div>
    );
}

export default StopHeader;
